import { render, staticRenderFns } from "./TemplateLongSentences.vue?vue&type=template&id=8d5ba288&scoped=true&"
import script from "./TemplateLongSentences.vue?vue&type=script&lang=js&"
export * from "./TemplateLongSentences.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLongSentences.vue?vue&type=style&index=0&id=8d5ba288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5ba288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCol,VIcon,VRow,VStepper,VStepperContent,VStepperItems})
